export const isIOS = navigator.userAgent.indexOf("like Mac") !== -1;
export const isAndroid = navigator.userAgent.indexOf("Android") !== -1;
